import React from 'react';
import { Link } from 'gatsby';

import Asset from '@src/components/Asset';

export default function ProductsList(props) {
    const { data } = props;
    const products = data.productsList;

    return (
        <div className={`relative spacing ${data.related ? 'border-top border-top--dashed' : ''}`}>
            {data.related ? <h6 className="h6">Related</h6> : null}
            <div className="grid grid--3 relative">
                {products.map((entry, i) => (
                    <div key={entry.id}>
                        {entry.multipleImages[0] ? (
                            <div className="mb-8px">
                                <Link to={`/${entry.uri}`}>
                                    <Asset
                                        data={entry.multipleImages[0].imageFile}
                                        title={entry.multipleImages[0].title}
                                    />
                                </Link>
                            </div>
                        ) : null}
                        <Link to={`/${entry.uri}`} className="link">
                            <p>{entry.title}</p>
                        </Link>
                        {entry.plainText && entry.plainText.length > 0 ? (
                            <Link to={`/${entry.uri}`} className="link">
                                <p>{entry.plainText}</p>
                            </Link>
                        ) : null}
                    </div>
                ))}
            </div>
        </div>
    );
}
